import { Skeleton } from '@ui/skeleton.tsx';
import { ChevronRight, HomeIcon } from 'lucide-react';

const BreadcrumbSkeleton = () => (
  <div className="flex flex-wrap items-center gap-1.5 break-words text-sm text-muted-foreground sm:gap-2.5">
    <Skeleton>
      <HomeIcon size={15} />
    </Skeleton>
    <span className="text-muted-foreground">
      <ChevronRight size={14} />
    </span>
    <Skeleton className="w-32 h-5 rounded-md bg-muted-foreground/10" />
    <span className="text-muted-foreground">
      <ChevronRight size={14} />
    </span>
    <Skeleton className="w-40 h-5 rounded-md bg-muted-foreground/10" />
  </div>
);

export { BreadcrumbSkeleton };
